import {StringHelper} from '../helpers/strings.helper';
import {AgentOutletWalletModel} from '../../shared/models/account.model';
import {ReplaySubject, Subject} from 'rxjs';
import {Injectable} from '@angular/core';
import {ApiClientHelper} from '../helpers/api-client.helper';
import {AppConfig} from '../../shared/config/app-config';
import {
	AgentDashBoardModel,
	AggregatorDashBoardModel,
	OutletManagerDashBoardModel
} from '../../shared/models/dashboard.model';
import {SavingsAccountBalanceModel} from '../../shared/models/account.model';

@Injectable()
export class AccountService {

	public allOutlets: Subject<AgentOutletWalletModel[]> = new ReplaySubject();
	public monitorGrafanaUrl: Subject<string> = new ReplaySubject();
	public featureAccess: Subject<string[]> = new ReplaySubject(1);
	userRole: any;

	constructor(
		private apiClientHelper: ApiClientHelper,
		public config: AppConfig,
	) {
	}


	getAgentManagerDashboardData(): Promise<OutletManagerDashBoardModel> {
		const url = `${this.config.MONIEPOINT_DASHBOARD}/api/v1/dashboard/agent-managers?trend=3`;
		return this.apiClientHelper.getForPromise(url);
	}

	getAgentDashboardData(): Promise<AgentDashBoardModel> {
		const url = `${this.config.MONIEPOINT_DASHBOARD}/api/v1/dashboard/agents?trend=30`;
		return this.apiClientHelper.getForPromise(url);
	}

	getAggregatorDashboardData(context): Promise<AggregatorDashBoardModel> {
		const url = `${this.config.MONIEPOINT_HOST}/api/v1/dashboard/${context}?trend=30`;
		return this.apiClientHelper.getForPromise(url);
	}


	getSavingBalance(): Promise<SavingsAccountBalanceModel[]> {
		const url = `${this.config.MONIEPOINT_SAVINGS}/api/v1/savings/savings-balance-data`;
		return this.apiClientHelper.getForPromise(url);
	}

	validateAccountDetails(params: any, cacheBoolean): Promise<AccountDetailsModel> {
		params = StringHelper.toUrlString(params);
		const url = this.config.MONIEPOINT_HOST + `/api/v1/validations/account?${params}&cacheAccountDetails=${cacheBoolean}`;
		return this.apiClientHelper.getForPromise(url);
	}

}


// Generated by https://quicktype.io

export interface AccountDetailsModel {
	responseCode: string;
	account: Account;
}

export interface Account {
	name: string;
	bvn: string;
	transactionReference: string;
}
